import { ModuleService } from './../module.service';
import { ModuleListComponent } from './../module-list/module-list.component';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AddModuleComponent } from '../add-module/add-module.component';
import { Claim } from '../model/claim';

@Component({
  selector: 'gate-module-overview',
  standalone: true,
  imports: [TranslatePipe, ButtonModule, ModuleListComponent, AddModuleComponent],
  templateUrl: './module-overview.component.html',
  styleUrl: './module-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleOverviewComponent{
  private moduleService = inject(ModuleService);
  private translateService = inject(TranslateService);
  public claims = signal<Claim[]>([]);

  constructor() {
    this.getClaims();
    this.translateService.onLangChange.subscribe(() => {
      this.translateClaimNames();
    });
  }
  private getClaims() {
    this.moduleService
      .getAllClaims()
      .then((claims) => {
        // Translate role names for each claim
        const translatedClaims = claims.map(claim => ({
          ...claim,
          translatedName: this.translateService.instant(`userManagement.roles.${claim.roleName?.toLocaleLowerCase()}`)
        }));
        this.claims.set(translatedClaims);
      })
      .catch((error) => console.error('Error fetching claims:', error));
  }

  private translateClaimNames() {
    this.claims.update((claims) => {
      return claims.map((claim) => ({
        ...claim,
        translatedName: this.translateService.instant(`userManagement.roles.${claim.roleName?.toLocaleLowerCase()}`),
      }));
    });
  }
}
